import { render, staticRenderFns } from "./BiddersList.vue?vue&type=template&id=590d4ea4&scoped=true&"
import script from "./BiddersList.vue?vue&type=script&lang=js&"
export * from "./BiddersList.vue?vue&type=script&lang=js&"
import style0 from "./BiddersList.vue?vue&type=style&index=0&id=590d4ea4&lang=scss&scoped=true&"
import style1 from "./BiddersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590d4ea4",
  null
  
)

export default component.exports